import { useQuery } from "@supabase-cache-helpers/postgrest-react-query";
import type { PostgrestResponseSuccess } from "@supabase/postgrest-js";
import type {
  PostgrestError,
  PostgrestSingleResponse,
} from "@supabase/supabase-js";
import {
  type DistributiveOmit,
  type UseBaseQueryOptions,
  type UseQueryOptions,
  type UseSuspenseQueryResult,
} from "@tanstack/react-query";

type UseSuspenseQuerySingleReturn<TResult> = DistributiveOmit<
  UseSuspenseQueryResult<
    PostgrestResponseSuccess<TResult>["data"],
    PostgrestError
  >,
  "refetch"
> &
  Pick<
    UseSuspenseQueryResult<PostgrestResponseSuccess<TResult>, PostgrestError>,
    "refetch"
  > &
  Pick<PostgrestResponseSuccess<TResult>, "count">;

export function useSuspenseQueryPostgrest<TResult>(
  query: PromiseLike<PostgrestSingleResponse<TResult>>,
  config?: Omit<
    UseQueryOptions<PostgrestSingleResponse<TResult>, PostgrestError>,
    "queryKey" | "queryFn"
  >,
): UseSuspenseQuerySingleReturn<TResult> {
  const suspense: Omit<
    UseBaseQueryOptions<PostgrestSingleResponse<TResult>, PostgrestError>,
    "queryKey" | "queryFn"
  > = {
    suspense: true,
    placeholderData: undefined,
  };

  return useQuery(query, {
    ...config,
    ...suspense,
  }) as UseSuspenseQuerySingleReturn<TResult>;
}
